const baseAlertOptions = {
  customClass: 'airbo',
  cancelBtnCssClass: 'cancel-v2',
  confirmBtnCssClass: 'confirm-v2',
  showCancel: true,
  style: {
    display: 'inherit',
    width: '520px',
  },
};

export default {
  STATUSES: {
    plan: 'plan',
    draft: 'draft',
    active: 'active',
    archive: 'archive',
  },
  TILE_STATUS: {
    user_submitted: 'Suggested',
    plan: 'Plan',
    draft: 'Proof',
    // share: 'Send',  // Commented out until it is ready to be overhauled into Edit
    active: 'Live',
    archive: 'Archive',
  },
  STATUS_CYCLE: {
    user_submitted: 'plan',
    plan: 'draft',
    draft: 'plan',
    active: 'archive',
    archive: 'active',
  },
  MENU_OPTS: {
    copy: {
      method: 'POST',
      url: 'copy_tile',
    },
    deleteConfirm: {
      method: 'DELETE',
      url: 'destroy_tiles',
    },
  },
  UNASSIGNED_AUDIENCE: {
    label: 'Unassigned',
    className: 'audience-option',
    value: null,
    color: '#fff',
  },
  AUDIENCE_SETTINGS: {
    label: 'Settings',
    className: 'audience-option',
    value: 'audience-settings',
    color: null,
    isSettings: true,
  },
  TOPIC_SETTINGS: {
    label: 'Manage Topics',
    className: 'audience-option',
    value: 'ribbonTag-settings',
    color: null,
    isSettings: true,
  },
  UNASSIGNED_RIBBON_TAG: {
    label: 'Unassigned',
    className: 'ribbon-tag-option',
    value: null,
    color: '#fff',
  },
  POST_AGAIN_MODAL_TEXT: {
    ...baseAlertOptions,
    title: 'Are you sure about that?',
    confirmBtnText: 'Post Again',
    text:
      'Users who have completed this Tile already will not see it again. If you want to re-use the content, it may be better to create a copy.',
  },
  post_MENU_ALERT_TEXT: {
    ...baseAlertOptions,
    title: 'Are you sure about that?',
    text:
      'Tiles are posted automatically when they are delivered. If you manually post a Tile, it will not appear in your next Tile Digest.',
  },
  delete_MENU_ALERT_TEXT: {
    customClass: 'airbo',
    cancelBtnCssClass: 'cancel-v2',
    confirmBtnCssClass: 'delete_confirm-v2',
    showCancel: true,
    style: {
      display: 'inherit',
      width: '520px',
    },
    title: 'Deleting a tile cannot be undone',
    text: 'Are you sure you want to delete this tile?',
  },
};
